module.exports = __webpack_public_path__ + "img/userAvatar.5084a384.png";